import { InlineTagFormController } from '../controller/InlineTagFormController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { TAG_NAME_MAX_LENGTH } from '../../../common/constants';
import { FormValidator } from '../../../../ui/gzForm/formField/types/form-validator';

export class InlineTagFormWebComponent extends BaseWebComponentElement {
  public controller: InlineTagFormController | null;

  protected _minLength = 0;
  protected _maxLength = TAG_NAME_MAX_LENGTH;
  protected _customValidators: FormValidator[] = [];

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: InlineTagFormController,
    });
  }

  public injectDependencies(dependencies: any): void {
    super.injectDependencies(dependencies);
  }

  set minLength(value: number) {
    this._minLength = value;
  }

  get minLength() {
    return this._minLength;
  }

  set maxLength(value: number) {
    this._maxLength = value;
  }

  get maxLength() {
    return this._maxLength;
  }

  set customValidators(value: FormValidator[]) {
    this._customValidators = value;
  }

  get customValidators() {
    return this._customValidators;
  }
}
